import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Languages configuration
    supportedLngs: ["en", "nl"], // Add all supported languages here
    fallbackLng: "nl", // Fallback language if detected language is not supported
    lng: "nl",
    debug: process.env.NODE_ENV === "development", // Enable debug logs in development
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
      ],
      caches: ["cookie", "localStorage"],
    },
    // Backend options (for HttpApi)
    backend: {
      loadPath: "/locales/{{lng}}/translations.json", // Path to translation files
    },
    // React specific configuration
    react: {
      useSuspense: true, // Recommended: use Suspense for async loading
    },

    // Interpolation settings (important for React)
    interpolation: {
      escapeValue: false, // Not needed for react as it escapes by default
    },
  });

export default i18n;
